import useDashboardPageSectionName from '@projects/hooks/useDashboardPageSectionName';

const useIsArchiveSection = () => {
  const section: string = useDashboardPageSectionName();

  return section === 'archive';
};

export default useIsArchiveSection;
